import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, switchMap} from 'rxjs';

import {AuthenticationService} from '../_services';
import { EnvService } from '../_services/configurations/env.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    private env = inject(EnvService);
    private apiURL = this.env?.readConfig()?.apiUrl;
    

    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        const user = this.authenticationService.userValue;
        const isLoggedIn = user && user.token;
        const isApiUrl = request.url.startsWith(this.apiURL) || request.url.startsWith(this.env?.readConfig()?.apiDomain);
        const alreadyHasAuthHeader = request.headers.has('Authorization');
        const url = request.url;
        const skipToken =
            url.includes('/auth/authenticate') ||
            url.includes('/auth/token/refresh') ||
            url.includes('/v2/auth/getOrCreateUser') ||
            (url.includes('/auth/authentication-provider') && request.method === 'GET');

        if (!isLoggedIn || !isApiUrl || skipToken) {
            return next.handle(request);
        }

        if (this.authenticationService.isTokenCloseToExpiration()) {
            return this.authenticationService.refreshToken(undefined, true).pipe(
                switchMap((refreshedUser) => {
                    return next.handle(this.addToken(request, refreshedUser.token));
                }),
                catchError(() => {
                    return next.handle(this.addToken(request, user.token));
                })
            );
        }

        return next.handle(this.addToken(request, user.token));
    }

    private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });
    }
}
